import React from "react";
import "./ScrollFadeSection.css";

const ScrollFadeSection = () => {
	return (
		<section className="scroll-fade">
			<div className="scroll-fade__overlay">
				<h1 className="scroll-fade__headline">
					Une vague d'amitié
					<br />
					<span>qui refaçonne la vie.</span>
				</h1>
			</div>

			<div className="scroll-fade__content">
				<p>
					Un entrepreneur ruiné et un pêcheur sans papiers nouent une amitié
					inattendue.
					<span>
						{" "}
						Ils s’entraident pour reprendre leur vie en main et redéfinir le
						succès.
					</span>
				</p>
				<div className="scroll-fade__details">
					<div className="scroll-fade__details-spacer"></div>
					<div className="scroll-fade__details-info">
						<div className="scroll-fade__details-bar"></div>
						<div className="scroll-fade__details-text">
							<p>
								Sortie 2026 | 15 minutes | Drame, Bromance.
								<br />
								de <span className="highlight">Elya Randrianaivo</span>
								<br />
								avec <span className="highlight">Paul Eun Ha</span>,{" "}
								<span className="highlight">Mark Anthony Howard</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default ScrollFadeSection;
